import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-receipt-app-form',
  templateUrl: './payment-receipt-app-form.component.html',
  styleUrls: ['./payment-receipt-app-form.component.css']
})
export class PaymentReceiptAppFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/payment-receipt-approval/payment-receipt-app-form/payment-receipt-app-form.component.ts